export const Plans = [
    {
        'title':'Vital',
        'monthly': 50.00,
        'annualy': 20000,
        // 'reimbursment': 70,
        // 'deduction': 500,
    },
    {
        'title':'Favorite',
        'monthly': 77.00,
        'annualy': 35000,
        // 'reimbursment': 80,
        // 'deduction': 250,
    },
    {
        'title':'Optimum',
        'monthly': 89.00,
        'annualy': 70000,
        // 'reimbursment': 90,
        // 'deduction': 100,
    }
]
export const Reimburse = [
    {
        'reimbursment': 70
    },
    {
        'reimbursment': 80
    },
    {
        'reimbursment': 90
    }
]
export const Deduction = [
    500, 
    1000, 
    2000
]
export const DeductionMap = {
        500: 100,
        1000: 250,
        2000: 500
}
export const BenifitsMap = {
        5000: 20000,
        10000: 35000,
        20000: 70000
}
export const CURRENCY = 'AED';

export const ALLOWED_EXTENSION = ".png, .jpg, .jpeg, .PNG, .JPG, .JPEG, .Png, .Jpg, .Jpeg";

export const COVERAGE_MAP = {
    dog:{
        joint:{
            claim: 12000,
            text: 'Joint luxation',
            '70_500': 8050,
            '80_500': 9200,
            '90_500': 10350,
            
            '70_1000': 7700,
            '80_1000': 8800,
            '90_1000': 9900,
            
            '70_2000': 7000,
            '80_2000': 8000,
            '90_2000': 9000,
            
            
        },
        cancer:{
            claim: 40000,
            text: 'Cancer',
            '70_500': 27650,
            '80_500': 31600,
            '90_500': 35550,
            
            '70_1000': 27300,
            '80_1000': 31200,
            '90_1000': 35100,
            
            '70_2000': 26600,
            '80_2000': 30400,
            '90_2000': 34200,
            
            
        },
        replacement:{
            claim: 30000,
            text: 'A total hit replacement',
            '70_500': 20650,
            '80_500': 23600,
            '90_500': 26550,
            
            '70_1000': 20300,
            '80_1000': 23200,
            '90_1000': 26100,
            
            '70_2000': 19600,
            '80_2000': 22400,
            '90_2000': 25200,
            
            
        },
        ingestion:{
            claim: 8000,
            text: 'A foreign object ingestion',
            '70_500': 5250,
            '80_500': 6000,
            '90_500': 6750,
            
            '70_1000': 4900,
            '80_1000': 5600,
            '90_1000': 6300,
            
            '70_2000': 4200,
            '80_2000': 4800,
            '90_2000': 5400,
            
            
        },
        injury:{
            claim: 20000,
            text: 'Traumatic injury',
            '70_500': 13650,
            '80_500': 15600,
            '90_500': 17550,
            
            '70_1000': 13300,
            '80_1000': 15200,
            '90_1000': 17100,
            
            '70_2000': 12600,
            '80_2000': 14400,
            '90_2000': 16200,
            
            
        }
    },
    cat:{
        fracture:{
            claim: 12000,
            text: 'Fracture repair',
            '70_500': 8050,
            '80_500': 9200,
            '90_500': 10350,
            
            '70_1000': 7700,
            '80_1000': 8800,
            '90_1000': 9900,
            
            '70_2000': 7000,
            '80_2000': 8000,
            '90_2000': 9000,
            
            
        },
        traumatic:{
            claim: 15000,
            text: 'Traumatic injury',
            '70_500': 10150,
            '80_500': 11600,
            '90_500': 13050,
            
            '70_1000': 9800,
            '80_1000': 11200,
            '90_1000': 12600,
            
            '70_2000': 9100,
            '80_2000': 10400,
            '90_2000': 11700,
            
            
        },
        rental:{
            claim: 13000,
            text: 'Renal (kidney) disorder',
            '70_500': 8750,
            '80_500': 10000,
            '90_500': 11250,
            
            '70_1000': 8400,
            '80_1000': 9600,
            '90_1000': 10800,
            
            '70_2000': 7700,
            '80_2000': 8800,
            '90_2000': 9900,
            
            
        },
        urethral:{
            claim: 11000,
            text: 'Urethral obstruction',
            '70_500': 7350,
            '80_500': 8400,
            '90_500': 9450,
            
            '70_1000': 7000,
            '80_1000': 8000,
            '90_1000': 9000,
            
            '70_2000': 6300,
            '80_2000': 7200,
            '90_2000': 8100,
            
            
        },
        cobacterial:{
            claim: 15000,
            text: 'Mycobacterial infection',
            '70_500': 10150,
            '80_500': 11600,
            '90_500': 13050,
            
            '70_1000': 9800,
            '80_1000': 11200,
            '90_1000': 12600,
            
            '70_2000': 9100,
            '80_2000': 10400,
            '90_2000': 11700,
            
            
        },
    },
};

export const Countries = {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia, Plurinational State of",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Democratic Republic of the Congo",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Côte d'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CW: "Curaçao",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    PF: "French Polynesia",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    HT: "Haiti",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "North Korea",
    KR: "South Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Republic of Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    MX: "Mexico",
    FM: "Micronesia, Federated States of",
    MD: "Republic of Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RO: "Romania",
    RU: "Russian",
    RW: "Rwanda",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SX: "Sint Maarten",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syria",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela, Bolivarian Republic of",
    VN: "Viet Nam",
    VI: "Virgin Islands",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
};

